import styled from '@emotion/styled';
import { ProgressBar } from '@zapier/design-system';
import {
  UNIVERSAL_TOPBAR_CONDENSED_HEIGHT,
  UNIVERSAL_TOPBAR_HEIGHT,
} from '@zapier/universal-layout';
import debounce from 'lodash.debounce';
import React, { useState } from 'react';

export const ArticleProgressBar = () => {
  const [scrollSize, setScrollSize] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);

  React.useEffect(() => {
    const updateScrollPosition = () => {
      setScrollPosition(window.scrollY);
    };

    const updateScrollSize = () => {
      setScrollSize(document.body.scrollHeight - window.screen.availHeight);
    };

    const updateScrollPositionDebounced = debounce(updateScrollPosition, 50, {
      trailing: true,
    });

    updateScrollSize();
    setScrollPosition(window.scrollY);

    window.addEventListener('resize', updateScrollSize);
    window.addEventListener('scroll', updateScrollPositionDebounced);

    return () => {
      window.removeEventListener('resize', updateScrollSize);
      window.removeEventListener('scroll', updateScrollPositionDebounced);
      updateScrollPositionDebounced.cancel();
    };
  }, []);

  if (scrollSize && scrollPosition) {
    return (
      <ProgressBarWrapper>
        <ProgressBar min={0} max={scrollSize} value={scrollPosition} />
      </ProgressBarWrapper>
    );
  }

  return null;
};

const ProgressBarWrapper = styled.div({
  width: '100%',
  position: 'fixed',
  // Universal nav (condensed) + secondary nav
  top: UNIVERSAL_TOPBAR_CONDENSED_HEIGHT + 61,
  left: 0,
  zIndex: 41,

  '@media (min-width: 450px)': {
    // Universal nav + secondary nav
    top: UNIVERSAL_TOPBAR_HEIGHT + 61,
  },
});
